import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import type { SpotSpeciesCount } from '../../types/api';

interface Props {
  data: SpotSpeciesCount[];
}

const TEAL = '#0d9488';

export function SpeciesBreakdownChart({ data }: Props) {
  return (
    <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-5 shadow-sm">
      <h2 className="mb-4 text-base font-semibold text-slate-900 dark:text-slate-50">Species Breakdown</h2>
      {data.length === 0 ? (
        <p className="text-sm text-slate-500 dark:text-slate-400">No data yet.</p>
      ) : (
        <ResponsiveContainer width="100%" height={Math.max(120, data.length * 36)}>
          <BarChart data={data} layout="vertical" margin={{ top: 0, right: 16, bottom: 0, left: 8 }}>
            <XAxis type="number" allowDecimals={false} tick={{ fontSize: 12 }} />
            <YAxis type="category" dataKey="fishTypeName" width={90} tick={{ fontSize: 12 }} />
            <Tooltip
              formatter={(value) => [value, 'Catches']}
              contentStyle={{ fontSize: 12 }}
            />
            <Bar dataKey="count" radius={[0, 4, 4, 0]}>
              {data.map((_, i) => (
                <Cell key={i} fill={TEAL} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
